module.exports = __webpack_public_path__ + "img/pc.fda019bf.svg";